<!--
 * @Author: ckj kaijun.cui@biz-united.com.cn
 * @Date: 2025-11-28 10:35:27
 * @LastEditors: Tang Hao
 * @LastEditTime: 2026-06-30 09:50:08
 * @Description:
-->
<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      requestType: 'POST',
      firstPickedDate: '',
    };
  },
  mounted() {
    this.getConfigList('main_list');
  },
  methods: {
    setSearchField(v) {
      const column = { ...v };
      if (column.field === 'startDate') {
        // 计算半年的毫秒数：60天 * 24小时 * 60分 * 60秒 * 1000毫秒
        // 注意：这里使用30天估算，如果业务需要更精确，可以用其他方法计算
        const halfYearInMs = 60 * 24 * 3600 * 1000;
        column.render.props = {
          ...column.render.props,
          type: 'datetimerange', // 时间类型参考element-ui
          startPlaceholder: '到账开始时间',
          endPlaceholder: '到账结束时间',
          defaultTime: ['00:00:00', '23:59:59'],
          pickerOptions: {
            onPick: ({ minDate, maxDate }) => {
              // 当用户选择了第一个日期（开始日期）时记录
              if (minDate) {
                this.firstPickedDate = minDate.getTime();
              }
            },
            disabledDate: (time) => {
              // 如果还没有选择开始日期，不禁用任何日期
              if (!this.firstPickedDate) {
                return false;
              }
              const currentTime = time.getTime();
              // 计算允许选择的日期范围：开始日期前后半年
              const minBoundary = this.firstPickedDate - halfYearInMs;
              const maxBoundary = this.firstPickedDate + halfYearInMs;
              // 当前日期在范围之外则禁用
              return currentTime <= minBoundary || currentTime >= maxBoundary;
            },
          },
        }; // 设置日期范围组件
        column.span = 8;
      }

      return column;
    },
    beforeGetList() {
      const params = this.searchFormData;
      if (params.startDate && params.startDate.length && typeof params.startDate === 'object') {
        const [startDate, endDate] = params.startDate;
        params.startDate = startDate;
        params.endDate = endDate;
      } else if (params.startDate && params.startDate.length && typeof params.startDate === 'string') {
        // 已经是日期格式了，不作处理
      } else { // 没有选择日期
        params.startDate = '';
        params.endDate = '';
      }
      this.searchFormData = {
        ...params,
      };
      return true;
    },
  },
};
</script>
